import { sentry } from '@frontend/tracking';
import { getSentryConfig } from '../third-party-scripts';

export function initializeSentry() {
  if (import.meta.env.MODE === 'production') {
    try {
      sentry.init(getSentryConfig());
    } catch (error) {
      console.error('Error initializing Sentry:', error);
    }
  } else {
    console.warn('Sentry is not initialized because the app is not running in production.');
  }
}
